import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { UpdateLoadLaneMovementRequest } from '@/types';
import { QUERY_KEYS } from '../../queryKeys';
import { loadlanes } from '../LoadLanes';

export const useUpdateLoadLaneMovement = (
  siteId?: number,
  customerId?: number,
) =>
  useMutation({
    mutationFn: (data: UpdateLoadLaneMovementRequest) =>
      loadlanes.updateLoadLaneMovement(data),
    onSuccess: (response) => {
      if (!response.success) return;

      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.loadLanes, siteId, customerId],
      });
    },
  });
